import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n'; // TODO get rid of this import - i18n should not be here

import { IconModule } from './../icon/icon.module';
import { TooltipModule } from './../tooltip/tooltip.module';
import { TruncateModule } from './../truncate/truncate.module';
import { InterviewEvaluationRatingComponent } from './interview-evaluation-rating.component';

@NgModule({
  declarations: [InterviewEvaluationRatingComponent],
  exports: [InterviewEvaluationRatingComponent],
  imports: [IconModule, CommonModule, TooltipModule, TruncateModule, I18nModule],
})
export class InterviewEvaluationRatingModule {}
export { InterviewEvaluationRatingComponent } from './interview-evaluation-rating.component';
